import React from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';

export default React.memo(ClickAwayListener);
